// Projects: real client work organised as case studies.
// Add a new project by appending an object to PROJECTS.
//
// Example shape:
// {
//   slug: "project-slug",
//   title: "Project Title",
//   location: "Residential / Commercial — short descriptor",
//   year: "2025",
//   type: "Custom Millwork",
//   discipline: ["High-End Rendering", "Custom Millwork"],
//   summary: "1-2 sentence headline summary.",
//   description: "Longer paragraph about the project.",
//   deliverables: ["Six photorealistic scenes", "Material study", ...],
//   software: ["SketchUp", "V-Ray", "Photoshop"],
//   status: "Visualization complete · production-ready",
//   coverScene: 0,
//   scenes: [
//     { src: "/projects/<slug>/scene-1.jpg", thumb: "/projects/<slug>/scene-1-thumb.jpg", alt: "..." },
//     ...
//   ],
//   shopDrawings: [
//     { title: "Plan", kind: "Plan · A-01", src: "/projects/<slug>/drawings/page-01.jpg", thumb: "/projects/<slug>/drawings/page-01-thumb.jpg" },
//     ...
//   ],
//   shopDrawingsPdf: "/projects/<slug>/drawings/Project-Shop-Drawings.pdf",
// }

export const PROJECTS = [];

export function getProjectBySlug(slug) {
  return PROJECTS.find((p) => p.slug === slug);
}
